module.exports = __webpack_public_path__ + "static/2front-strategy-1-e9f3e01128e7d6d812abc67707d90f30.png";